<template>
  <div id="smartTown">
    <div class="title">国家三级公立医院绩效考核操作手册(2022 版)</div>
    <div class="text">为持续深入贯彻落实《国务院办公厅关于加强三级公立医院 绩效考核工作的意见》(国办发〔2019〕4 号)要求，保证三级公立医院绩效考核工作规范化、标准化、同质化，通过现场调研、 会议座谈、平台反馈、自评报告等多渠道搜集相关单位意见建议。 在《国家三级公立医院绩效考核操作手册(2020 修订版)》(以 下简称《操作手册(2020 修订版)》)的基础上，结合最新政策文件，组织专家研究，并在部分医院针对调整内容进行试填报后， 修订形成《国家三级公立医院绩效考核操作手册(2022 版)》。 </div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.nhc.gov.cn/yzygj/ylyxjg/202204/d61b7201a56643d1a876e103340e5897.shtml')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}
.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news9.vue